import React, { useEffect, useState } from 'react';
import { cellRendererCheck, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';

const columns = [
    {
        dataField: 'options',
        text: 'Options',
        sort: false,
        width: 100,
        show: true,
        hidecolFilter: true,        
        action: true
    },
    {
        dataField: 'claimType',
        text: 'Claim Type',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.claimType),
    },
    {
        dataField: 'prescriptionNumber',
        text: 'Rx #',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData) => cellRendererCheck(rowData.prescriptionNumber),
    },
    {
        dataField: 'patientId',
        text: 'Patient ID',
        sort: false,
        width: 140,
        show: true,
        inputType: 'number',
        hideColFilter:true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.patientId),
    },
    {
        dataField: 'eligibityCode',
        text: 'Eligibility Code',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.eligibityCode),
    },
    {
        dataField: 'dateOfDispense',
        text: 'Date Of Service ',
        sort: true,
        width: 140,
        show: true,
        inputType: 'date',
        cellRenderer: (rowData) => dateFormate(rowData.dateOfDispense),
    },
    {
        dataField: 'ndc',
        text: 'NDC',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.ndc),
    },
    {
        dataField: 'quantity',
        text: 'Quantity',
        sort: true,
        width: 140,
        show: true,
        inputType: 'number',
        cellRenderer: (rowData) => cellRendererCheck(rowData.quantity),
    },
    {
        dataField: 'daysSupply',
        text: 'Days Supply',
        sort: false,
        width: 140,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.daysSupply),
    },
    {
        dataField: 'claimStatus',
        text: 'Claim Status',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.claimStatus),
    },
    {
        dataField: 'pharmacyName',
        text: 'Pharmacy',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.pharmacyName),
    },    
    {
        dataField: 'storeNumber',
        text: 'Store',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.storeNumber),
    },
    
];

const UnitsDispensedTable = ({
    tenantID,
    data,
    loading,
    onExport,
    filters,
    totalSize,
    onPageChange,
    refetch,
    setLoading,
    onSearchColumnFilters,
    reset,
}) => {
    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    useEffect(() => {
        setState({ tableData: data, backUpData: data });
    }, [data]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const handleFilterCancel = () => {
        refetch(true);
    };

    const handleSearchColumnFilters = (colFilter) => {
        if (onSearchColumnFilters) {
            const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
            onSearchColumnFilters(filter);
            setState({
                filters: filter,
            });
        }
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };

    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const { filters: colFilter, backUpData } = state;


    return <div className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={data.length > 0 ? 'fixed-height' : 'default'}>
        <ReactStrapTable
            id='inventory-table'
            fixedColumn
            data={backUpData}
            loading={loading}
            columns={columns}
            hasScrollArrow={false}
            onPageSizeChange={onPageSizeChange}
            pageSize={colFilter.pageSize}
            onExport={onExport}
            hasPagination
            onPageChange={onHandlePageChange}
            currentPage={colFilter.currentPage}
            totalRecords={totalSize}
            filters={colFilter}
            handleSort={handleSort}
            onFilterCancel={handleFilterCancel}
            onSearchColumnFilters={handleSearchColumnFilters}
        />
    </div>;
};

export default UnitsDispensedTable;
